import { getMessaging, getToken, onMessage } from "firebase/messaging";
import firebaseApp from "./FirebaseMessagingConfig";
import { NotificationSaveTokenApi } from "./NotificationApi";
import { registerServiceWorker } from "./firebase-sw-register";

const messaging = getMessaging(firebaseApp);

export const requestNotificationPermission = async (email) => {
  console.log("🔔 Requesting notification permission for email:", email);

  try {
    const isWebEnvironment = typeof window !== "undefined" && window.document;
    const isWebView = /wv/.test(navigator.userAgent) || !!window.AndroidInterface;

    if (isWebEnvironment && !isWebView) {
      // 🌐 Standard web browser flow
      console.log("✅ Detected browser environment");
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.warn("❌ Notification permission not granted");
        return;
      }

      const serviceWorkerRegistration = await registerServiceWorker();
      // const token = await getToken(messaging, {
      //   vapidKey: "BAAyCnmxjvoOsPi3dlbbkIKB8JEGuEj1WeQqmcvpOaeW1FXSuTxQF5Ah2eYbxltcYiJFVmDNAHFXYaDOfqqNRQU",
      //   serviceWorkerRegistration,
      // });

      const token = process.env.REACT_APP_COMMON_NOTIFICATION_TOKEN
      console.log("token---->",token);
      

      if (!token) {
        console.warn("❌ No FCM token received in browser");
        return;
      }

      return await saveTokenToBackend(email, token);

    } else if (isWebView) {
      // 📱 WebView or SDK/native wrapper flow
      console.log("✅ Detected WebView / SDK environment");

      if (window.AndroidInterface?.getFCMToken) {
        const token = window.AndroidInterface.getFCMToken();

        if (!token) {
          console.warn("❌ No FCM token received from Android interface");
          return;
        }

        return await saveTokenToBackend(email, token);

      } else {
        console.warn("❌ No AndroidInterface.getFCMToken found");
        // Optionally handle iOS native token here
      }

    } else {
      console.warn("❌ Unknown or unsupported environment");
    }

  } catch (err) {
    console.error("❌ Notification permission error:", err);
  }
};

// Helper to save token
async function saveTokenToBackend(email, token) {
  try {
    console.log("💾 Saving token to backend:", token);
    return await NotificationSaveTokenApi({ email, token });
  } catch (error) {
    console.error("❌ Error saving token to backend:", error);
  }
}

// Foreground message listener (browser only)
export const onForegroundMessage = (callback) => {
  if (typeof window !== 'undefined' && window.document) {
    onMessage(messaging, callback);
  }
};
